import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import classNames from 'classnames';
import { RegistersPanelBody } from '../context/PanelComponentRegistrationContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UIPanelBody = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs("div", Object.assign({}, rest, {
    className: classNames(className, 'private-panel__body'),
    ref: ref,
    children: [/*#__PURE__*/_jsx(RegistersPanelBody, {}), children]
  }));
});
UIPanelBody.propTypes = {
  children: PropTypes.node
};
UIPanelBody.displayName = 'UIPanelBody';
export default UIPanelBody;